import { DisabledPrompt, useBCMSContext, useBCMSModal } from "@bcm-dev/bcms-vite";
import { PrimaryButton, SecondaryButton } from 'components/ui';
import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter } from '../..';
import "./styles.css";

/**
 * @function TASPositivePayCancelAddCheckModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the TASPositivePayCancelAddCheckModal
 */
export default function TASPositivePayCancelAddCheckModal(props) {
  const { onYesClick } = props.data ?? {};
  const { close } = useBCMSModal();
  const globalController = useBCMSContext();

  const _onYesClick = evt => {
    onYesClick();
    close("TASPositivePayCancelAddCheckModal");
  };
  const closeModal = evt => close("TASPositivePayCancelAddCheckModal");

  return (
    <CustomModal title="Cancel Change" id="TASPositivePayCancelAddCheckModal" 
    className="tas-positive-pay-cancel-add-check-modal mobile-view-modal">
      <CustomModalContent>
        <p>Are you sure you want to cancel the change you made?</p>
      </CustomModalContent>
      <CustomModalFooter>
        <SecondaryButton text="No" onClick={ closeModal } />
        <DisabledPrompt>
          <PrimaryButton className="set-width" text="Yes" onClick={ undefined } />
        </DisabledPrompt>
      </CustomModalFooter>
    </CustomModal>
  );
}
